import { FC } from 'react';
import { Box } from '../BoxNew'
import { Icon } from '../IconNew'
import { Text } from '../TextNew'
import { DefaultViewStyles } from './styles'
import { ListHeaderProps, ListHeaderType } from './types'

const ListHeader: FC<ListHeaderProps> = ({
  data,
  onPress,
  type = ListHeaderType.DEFAULT,
  hide = false,
}: ListHeaderProps) => {
  if (hide) {
    return null
  }

  return (
    <Box {...DefaultViewStyles.ListHeaderContainer[type]}>
      {data.LeftSideString && !data.leftIconDisplay && (
        <Text type="titleMedium20" title={data.LeftSideString} color="BLACK_75" />
      )}
      {data.leftIconDisplay && <Icon id="LOCATE" type="primary" size="FONT_SIZE_MEDIUM" />}
      {data.RightSideString && !data.rightIconDisplay && (
        <Box onPress={onPress}>
          <Text type="titleBold18" title={data.RightSideString} color="PRIMARY" />
        </Box>
      )}
      {data.rightIconDisplay && (
        <Box onPress={onPress}>
          <Icon id="CLOSE" type="primary" size="FONT_SIZE_2_EXTRA_LARGE" />
        </Box>
      )}
    </Box>
  )
}

export { ListHeader }
